export const apiGet = async (url) => {
    try {
        return await fetch(url).then(response => response.json())
    } catch (error) {
        return { errorDescripcion: 'Error al Consultar', transaccion: false }
    }
}

export const apiPost = async (url, param) => {
    try {
        return await fetch(url,
            {
                method: "post",
                headers: {
                    Accept: "application/json"
                },
                body: JSON.stringify(param)
            }).then(response => response.json())
    } catch (error) {
        return { errorDescripcion: 'Error al Consultar', transaccion: false, error }
    }
}

export const apiPost2 = async (url, param) => {
    try {
        const response = await fetch(url,
            {
                method: "post",
                headers: {
                    Accept: "application/json"
                },
                body: JSON.stringify(param)
            })

            return  await response.json()
    } catch (error) {
        return { errorDescripcion: 'Error al Consultar', transaccion: false, error }
    }
}